import { render, staticRenderFns } from "./tips-add.vue?vue&type=template&id=1cc6838a&"
import script from "./tips-add.vue?vue&type=script&lang=js&"
export * from "./tips-add.vue?vue&type=script&lang=js&"
import style0 from "./tips-add.vue?vue&type=style&index=0&id=1cc6838a&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports